// client/src/pages/NotFoundPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import FlightIcon from '@mui/icons-material/Flight';

const NotFoundPage = () => (
  <Container maxWidth="sm" sx={{ py: { xs: 8, md: 12 }, textAlign: 'center' }}>
    <Box sx={{ color: 'primary.main', mb: 1 }}>
      <FlightIcon sx={{ fontSize: 64, transform: 'rotate(135deg)' }} />
    </Box>
    <Typography variant="overline" color="text.secondary" sx={{ display: 'block' }}>Error 404</Typography>
    <Typography component="h1" sx={{ fontSize: { xs: '2.25rem', md: '3rem' }, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1, mb: 1.5 }}>
      This page has flown off course.
    </Typography>
    <Typography color="text.secondary" sx={{ mb: 4 }}>
      The link may be broken, or the page may have moved.
    </Typography>
    <Button component={Link} to="/" variant="contained" size="large">Back to home</Button>
  </Container>
);

export default NotFoundPage;
